import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminKycApplicationListItemDto } from '../../../_core/_model/compliance';
import { ComplianceApiService } from '../../../_core/_services/_compliance/compliance-api.service';
import { NotificationService } from '../../../_core/_services/notification.service';

@Component({
  selector: 'app-admin-kyc-applications',
  standalone: false,
  templateUrl: './admin-kyc-applications.html',
  styleUrl: './admin-kyc-applications.css',
})
export class AdminKycApplications implements OnInit {
  loading = false;
  error: string | null = null;
  items: AdminKycApplicationListItemDto[] = [];

  filter = {
    status: '',
    jurisdictionCode: '',
    tierCode: '',
    customerType: '',
    productType: '',
    search: '',
    page: 1
  };

  constructor(
    private notifyService: NotificationService,
    private api: ComplianceApiService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = null;

    this.api.getAdminReviews(this.filter).subscribe({
      next: (res) => {
        this.items = res.data || [];
        this.loading = false;
      },
      error: (err) => {
        this.error = err?.error?.message || 'Failed to load KYC applications.';
        this.notifyService.showError(this.error!, 'Error');
        this.loading = false;
      }
    });
  }

  open(item: AdminKycApplicationListItemDto): void {
    this.router.navigate(['/admin/compliance/applications', item.applicationId]);
  }

  resetFilters(): void {
    this.filter = {
      status: '',
      jurisdictionCode: '',
      tierCode: '',
      customerType: '',
      productType: '',
      search: '',
      page: 1
    };
    this.load();
  }

  getStatusClass(status?: string): string {
    switch (status) {
      case 'Approved': return 'text-bg-success';
      case 'Rejected': return 'text-bg-danger';
      case 'Submitted':
      case 'UnderReview': return 'text-bg-warning';
      default: return 'text-bg-secondary';
    }
  }
}